/**
 * retinaLogos
 * headerFixed
 * mobileNav
 * ajaxContactForm
 * alertBox
 * swiper_tab
 * swiper_tab2
 * swiper_tab3
 * tabs
 * goTop
 * flatAccordions
 * flatAccordions2
 * dropdown
 * flatCounter
 * ButtonSlide
 * Preloader
 */

; (function ($) {
    "use strict";

    var isMobile = {
        Android: function () {
            return navigator.userAgent.match(/Android/i);
        },
        BlackBerry: function () {
            return navigator.userAgent.match(/BlackBerry/i);
        },
        iOS: function () {
            return navigator.userAgent.match(/iPhone|iPad|iPod/i);
        },
        Opera: function () {
            return navigator.userAgent.match(/Opera Mini/i);
        },
        Windows: function () {
            return navigator.userAgent.match(/IEMobile/i);
        },
        any: function () {
            return (
                isMobile.Android() ||
                isMobile.BlackBerry() ||
                isMobile.iOS() ||
                isMobile.Opera() ||
                isMobile.Windows()
            );
        },
    };

    var themesflatTheme = {

        // Main init function
        init: function () {
            this.config();
            this.events();
        },

        // Define vars for caching
        config: function () {
            this.config = {
                $window: $(window),
                $document: $(document),
            };
        },

        // Events
        events: function () {
            var self = this;

            // Run on document ready
            self.config.$document.on('ready', function () {

                // Retina Logos
                self.retinaLogo();

            });

            // Run on Window Load
            self.config.$window.on('load', function () {

            });
        },

        // Retina Logos
        retinaLogo: function () {
            var retina = window.devicePixelRatio > 1 ? true : false;
            var $logo = $('.header__logo img');
            var $logo2 = $('.footer_logo img');
            var $logo_retina = $logo.data('retina');

            if (retina && $logo_retina) {
                $logo.attr({
                    src: $logo.data('retina'),
                    width: $logo.data('width'),
                    height: $logo.data('height')
                });
            }
            if (retina && $logo_retina) {
                $logo2.attr({
                    src: $logo.data('retina'),
                    width: $logo.data('width'),
                    height: $logo.data('height')
                });
            }
        },
    }; // end themesflatTheme

    // Start things up
    themesflatTheme.init();

    var ajaxContactForm = function () {
        $('#contactform,#commentform').each(function () {
            $(this).validate({
                submitHandler: function (form) {
                    var $form = $(form),
                        str = $form.serialize(),
                        loading = $('<div />', { 'class': 'loading' });

                    $.ajax({
                        type: "POST",
                        url: $form.attr('action'),
                        data: str,
                        beforeSend: function () {
                            $form.find('.form-submit,comment-form').append(loading);
                        },
                        success: function (msg) {
                            var result, cls;
                            if (msg === 'Success') {
                                result = 'Message Sent Successfully To Email Administrator. ( You can change the email management a very easy way to get the message of customers in the user manual )';
                                cls = 'msg-success';
                            } else {
                                result = 'Error sending email.';
                                cls = 'msg-error';
                            }

                            $form.prepend(
                                $('<div />', {
                                    'class': 'flat-alert ' + cls,
                                    'text': result
                                }).append(
                                    $('<a class="close" href="#"><i class="fa fa-close"></i></a>')
                                )
                            );

                            $form.find(':input').not('.submit').val('');
                        },
                        complete: function (xhr, status, error_thrown) {
                            $form.find('.loading').remove();
                        }
                    });
                }
            });
        }); // each contactform
    };

    var retinaLogos = function() {
        var retina = window.devicePixelRatio > 1 ? true : false;
        //   if(retina) {
        //       $('.header__logo').find('img').attr( {src:'assets/images/logo/logo@2x.png',width:'157',height:'30'} );
        //       $('.logo_footer').find('img').attr( {src:'assets/images/logo/logo2@2x.png',width:'230',height:'44'} );
        //     }
    };


    // Header Fixed
    var headerFixed = function () {
        if ($('body').hasClass('header-fixed')) {
            var nav = $('#header_main');
            if (nav.length) {
                var headerHeight = nav.height(),
                    injectSpace = $("<div>", {
                        height: headerHeight,
                    });
                injectSpace.hide();
                if ($("header").hasClass("style-absolute")) {
                    injectSpace.hide();
                } else  {
                    injectSpace.insertAfter(nav);
                }
                $(window).on('load scroll', function () {
                    if ($(window).scrollTop() > 200) {
                        nav.addClass('is-fixed');
                        injectSpace.show();
                    } else {
                        nav.removeClass('is-fixed');
                        injectSpace.hide();
                    }

                    if ($(window).scrollTop() > 300) {
                        nav.addClass('is-small');
                    } else {
                        nav.removeClass('is-small');
                    }
                })
            }
        }
    };

    // Mobile Navigation
    var mobileNav = function () {
        var mobile = window.matchMedia("(max-width: 991px)");
        var wrapMenu = $("#site-header-inner");
        var navExtw = $(".nav-extend.active");
        var navExt = $(".nav-extend.active").children();

        responsivemenu(mobile);

        mobile.addListener(responsivemenu);

        function responsivemenu(mobile) {
            if (mobile.matches) {
                $("#main-nav")
                    .attr("id", "main-nav-mobi")
                    .appendTo("#header_main")
                    .hide()
                    .children(".menu")
                    .append(navExt)
                    .find("li:has(ul)")
                    .children("ul")
                    .removeAttr("style")
                    .hide()
                    .before('<span class="arrow"></span>');
            } else {
                $("#main-nav-mobi")
                    .attr("id", "main-nav")
                    .removeAttr("style")
                    .prependTo(wrapMenu)
                    .find(".ext")
                    .appendTo(navExtw)
                    .parent()
                    .siblings("#main-nav")
                    .find(".sub-menu")
                    .removeAttr("style")
                    .prev()
                    .remove();

                $(".mobile-button").removeClass("active");
                $(".sub-menu").css({ display: "block" });
            }
        }
        $(document).on("click", ".mobile-button", function () {
            $(this).toggleClass("active");
            $("#main-nav-mobi").slideToggle();
        });
        $(document).on("click", "#main-nav-mobi .arrow", function () {
            $(this).toggleClass("active").next().slideToggle();
        });


    };

    $(function() {
        $(".btn-side").click(function() {
            $(this).toggleClass("active");
            $('.sidebar-content').toggleClass("active");
        });
    });
    var ajaxSubscribe = {
        obj: {
            subscribeEmail: $('#subscribe-email'),
            subscribeButton: $('#subscribe-button'),
            subscribeMsg: $('#subscribe-msg'),
            subscribeContent: $("#subscribe-content"),
            dataMailchimp: $('#subscribe-form').attr('data-mailchimp'),
            success_message: '<div class="notification_ok">Thank you for joining our mailing list! Please check your email for a confirmation link.</div>',
            failure_message: '<div class="notification_error">Error! <strong>There was a problem processing your submission.</strong></div>',
            noticeError: '<div class="notification_error">{msg}</div>',
            noticeInfo: '<div class="notification_error">{msg}</div>',
            basicAction: 'mail/subscribe.php',
            mailChimpAction: 'mail/subscribe-mailchimp.php'
        },

        eventLoad: function () {
            var objUse = ajaxSubscribe.obj;

            $(objUse.subscribeButton).on('click', function () {
                if (window.ajaxCalling) return;
                var isMailchimp = objUse.dataMailchimp === 'true';

                if (isMailchimp) {
                    ajaxSubscribe.ajaxCall(objUse.mailChimpAction);
                } else {
                    ajaxSubscribe.ajaxCall(objUse.basicAction);
                }
            });
        },

        ajaxCall: function (action) {
            window.ajaxCalling = true;
            var objUse = ajaxSubscribe.obj;
            var messageDiv = objUse.subscribeMsg.html('').hide();
            $.ajax({
                url: action,
                type: 'POST',
                dataType: 'json',
                data: {
                    subscribeEmail: objUse.subscribeEmail.val()
                },
                success: function (responseData, textStatus, jqXHR) {
                    if (responseData.status) {
                        objUse.subscribeContent.fadeOut(500, function () {
                            messageDiv.html(objUse.success_message).fadeIn(500);
                        });
                    } else {
                        switch (responseData.msg) {
                            case "email-required":
                                messageDiv.html(objUse.noticeError.replace('{msg}', 'Error! <strong>Email is required.</strong>'));
                                break;
                            case "email-err":
                                messageDiv.html(objUse.noticeError.replace('{msg}', 'Error! <strong>Email invalid.</strong>'));
                                break;
                            case "duplicate":
                                messageDiv.html(objUse.noticeError.replace('{msg}', 'Error! <strong>Email is duplicate.</strong>'));
                                break;
                            case "filewrite":
                                messageDiv.html(objUse.noticeInfo.replace('{msg}', 'Error! <strong>Mail list file is open.</strong>'));
                                break;
                            case "undefined":
                                messageDiv.html(objUse.noticeInfo.replace('{msg}', 'Error! <strong>undefined error.</strong>'));
                                break;
                            case "api-error":
                                objUse.subscribeContent.fadeOut(500, function () {
                                    messageDiv.html(objUse.failure_message);
                                });
                        }
                        messageDiv.fadeIn(500);
                    }
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    alert('Connection error');
                },
                complete: function (data) {
                    window.ajaxCalling = false;
                }
            });
        }
    };

    var alertBox = function () {
        $(document).on('click', '.close', function (e) {
            $(this).closest('.flat-alert').remove();
            e.preventDefault();
        })

    };

    var flatAccordion = function() {
        var args = {duration: 600};
        $('.flat-toggle .toggle-title.active').siblings('.toggle-content').show();

        $('.flat-toggle.enable .toggle-title').on('click', function() {
            $(this).closest('.flat-toggle').find('.toggle-content').slideToggle(args);
            $(this).toggleClass('active');
        }); // toggle

        $('.flat-accordion .toggle-title').on('click', function () {
            $('.flat-accordion .flat-toggle').removeClass('active');
            $(this).closest('.flat-toggle').toggleClass('active');

            if( !$(this).is('.active') ) {
                $(this).closest('.flat-accordion').find('.toggle-title.active').toggleClass('active').next().slideToggle(args);
                $(this).toggleClass('active');
                $(this).next().slideToggle(args);
            } else {
                $(this).toggleClass('active');
                $(this).next().slideToggle(args);
                $('.flat-accordion .flat-toggle').removeClass('active');
            }
        }); // accordion
    };

    var tabs = function(){
        $('.flat-tabs').each(function(){
            $(this).find('.content-tab').children().hide();
            $(this).find('.content-tab').children().first().show();
            $(this).find('.menu-tab').children('li').on('click',function(){
                var liActive = $(this).index();
                var contentActive=$(this).siblings().removeClass('active').parents('.flat-tabs').find('.content-tab').children().eq(liActive);
                contentActive.addClass('active').fadeIn("slow");
                contentActive.siblings().removeClass('active');
                $(this).addClass('active').parents('.flat-tabs').find('.content-tab').children().eq(liActive).siblings().hide();
                swiper_tab();
                swiper_tab2();
                swiper_tab3();
            });
        });
    };

    var swiper_tab = function(){
        var swiper_tab =  new Swiper(".slider-3", {
            loop:false,
            slidesPerView: 1,
            slidesPerColumn: 2,
            slidesPerColumnFill: 'row',
            spaceBetween: 30,
            navigation: {
                clickable: true,
                nextEl: ".next_slider-3",
                prevEl: ".prev_slider-3",
            },
            breakpoints: {
                576: {
                    slidesPerView: 1,
                    slidesPerColumn: 2,
                    spaceBetween: 30,
                },
                992: {
                    slidesPerView: 2,
                    slidesPerColumn: 2,
                    spaceBetween: 30,
                },
                1200: {
                    slidesPerView: 2,
                    slidesPerColumn: 2,
                    spaceBetween: 30,
                },
            },
        });
    };

    var swiper_tab2 = function(){
        var swiper_tab2 =  new Swiper(".slider-4", {
            loop:false,
            slidesPerView: 1,
            slidesPerColumn: 2,
            slidesPerColumnFill: 'row',
            spaceBetween: 30,
            navigation: {
                clickable: true,
                nextEl: ".next_slider-4",
                prevEl: ".prev_slider-4",
            },
            breakpoints: {
                576: {
                    slidesPerView: 2,
                    slidesPerColumn: 2,
                    spaceBetween: 30,
                },
                992: {
                    slidesPerView: 2,
                    slidesPerColumn: 2,
                    spaceBetween: 30,
                },
                1200: {
                    slidesPerView: 2,
                    slidesPerColumn: 2,
                    spaceBetween: 30,
                },
            },
        });
    };

    var swiper_tab3 = function(){
        var swiper_tab3 =  new Swiper(".slider-5", {
            loop:false,
            slidesPerView: 1,
            slidesPerColumn: 2,
            slidesPerColumnFill: 'row',
            spaceBetween: 30,
            navigation: {
                clickable: true,
                nextEl: ".next_slider-5",
                prevEl: ".prev_slider-5",
            },
            breakpoints: {
                576: {
                    slidesPerView: 2,
                    slidesPerColumn: 2,
                    spaceBetween: 30,
                },
                992: {
                    slidesPerView: 2,
                    slidesPerColumn: 2,
                    spaceBetween: 30,
                },
                1200: {
                    slidesPerView: 2,
                    slidesPerColumn: 2,
                    spaceBetween: 30,
                },
            },
        });
    };


    var goTop = function() {
        $(window).scroll(function() {
            if ($(this).scrollTop() > 800) {
                $('#scroll-top').addClass('show');
            } else {
                $('#scroll-top').removeClass('show');
            }
        });

        $('#scroll-top').on('click', function () {
            $("html, body").animate({ scrollTop: 0 }, 200, 'easeInOutExpo');
            return false;
        });
    };

    var dropdown = function(id){
        var obj = $(id+'.dropdown');
        var btn = obj.find('.btn-selector');
        var dd = obj.find('ul');
        var opt = dd.find('li');
        opt.on("click", function() {
            // dd.hide();
            var txt = $(this).text();
            opt.removeClass("active");
            $(this).toggleClass("active");
            btn.text(txt);
        });
    };

    var flatAccordions2 = function() {
        var args = {easing:'easeOutExpo', duration:400};
        $('.widget.active').find('.content-widget').show();
        $('.widget-title').on('click', function () {
            if ( !$(this).parent().is('.active') ) {
                $(this).parent().toggleClass('active')
                    .children('.content-widget').slideToggle(args)
                    .children('.content-widget').slideToggle(args);
                this.addClass('show');
            } else {
                $(this).parent().toggleClass('active');
                $(this).next().slideToggle(args);
            }
        });
    };

    function Preloader() {
        if ($(".preloader").length) {
            $("body").addClass("page-loaded");
            $(".preloader").delay(500).fadeOut(0);
        }
    }

    var flatCounter = function () {
        if ($(document.body).hasClass("counter-scroll")) {
            var a = 0;
            $(window).scroll(function () {
                var oTop = $(".counter").offset().top - window.innerHeight;
                if (a == 0 && $(window).scrollTop() > oTop) {
                    if ($().countTo) {
                        $(".counter")
                            .find(".count-number")
                            .each(function () {
                                var to = $(this).data("to"),
                                    speed = $(this).data("speed"),
                                    formatter = $(this).data('formatter');
                                $(this).countTo({
                                    to: to,
                                    speed: speed,
                                    formatter: formatter,
                                });
                            });
                    }
                    a = 1;
                }
            });
        }
    };

    var popupVideo = function () {
        if ($().magnificPopup) {
            $(".popup-youtube").magnificPopup({
                type: "iframe",
                mainClass: "mfp-fade",
                removalDelay: 160,
                preloader: false,
                fixedContentPos: false,
            });
        }
    };


    $(function() {
        $(".search").click(function() {
            $('.input-box').addClass("open");
        });
        $(".close-icon").click(function() {
            $('.input-box').removeClass("open");
        });
    });

    var sticky = function() {
        if ($('body').hasClass('sticky-scroll')) {
            new StickySidebar('#sidebar-sticky', {
                topSpacing: 0,
                bottomSpacing: 0,
                containerSelector: '.page-menu1-wrap',
                innerWrapperSelector: '.po-sticky'
            });
        }
    }

    var instagramCarousel = function () {
        $('.instagram-carousel').each(function () {
            $(this).find('.single-instagram-post')
                .on('auxclick click', function (e) {
                    e.preventDefault();
                })
                .on('middleclick', function (e) {
                    window.open($(this).attr('data-permalink'));
                });

            $(this).magnificPopup({
                type: 'image',
                delegate: 'a',
                mainClass: 'mfp-fade',
                gallery: {
                    enabled: true,
                    navigateByImgClick: false,
                },
                removalDelay: 300,
                preloader: false,
                preload: [0, 0],
                fixedContentPos: false,
                callbacks: {
                    buildControls: function() {

                        let dots = $("<div class='mfp-dots'></div>");

                        let popup = this;

                        popup._checkIfClose = function(target) {

                            if($(target).hasClass('mfp-prevent-close')) {
                                return;
                            }

                            let closeOnContent = popup.st.closeOnContentClick;
                            let closeOnBg = popup.st.closeOnBgClick;

                            if(closeOnContent && closeOnBg) {
                                return true;
                            } else {

                                // We don't close the popup if click is on navigation dots
                                if($(target).hasClass('mfp-dots') || $(target).hasClass('mfp-dot')) {
                                    return false;
                                }

                                // We close the popup if click is on close button or on preloader. Or if there is no content.
                                if(!popup.content || $(target).hasClass('mfp-close') || (popup.preloader && target === popup.preloader[0]) ) {
                                    return true;
                                }

                                // if click is outside the content
                                if(  (target !== popup.content[0] && !$.contains(popup.content[0], target))  ) {
                                    if(closeOnBg) {
                                        // last check, if the clicked element is in DOM, (in case it's removed onclick)
                                        if( $.contains(document, target) ) {
                                            return true;
                                        }
                                    }
                                } else if(closeOnContent) {
                                    return true;
                                }

                            }
                            return false;
                        };

                        let children = Object.values(popup.st.items).slice(0, popup.st.items.length);

                        children.forEach((item, index)  => {
                            dots.append("<button type='button' class='mfp-dot' aria-label='post "+index+"' data-index='"+index+"'></button>");
                        });

                        popup.contentContainer.append(dots);
                    },
                    open: function () {
                        $('body').addClass('mfp-opened mfp-carousel-opened');
                    },
                    close: function () {
                        $('body').removeClass('mfp-opened mfp-carousel-opened');
                    },
                    imageLoadComplete: function () {
                        let popup = this;
                        let currItem = popup.currItem;

                        $(currItem.img).on('click middleclick', function () {
                            window.open(currItem.el.attr('data-permalink'));
                        });

                        popup.contentContainer.append(popup.arrowLeft.add(popup.arrowRight));

                        popup.contentContainer.find(".mfp-dots .mfp-dot").removeClass('mfp-dot-active');
                        popup.contentContainer.find(".mfp-dots .mfp-dot[data-index="+currItem.index+"]").addClass('mfp-dot-active');

                        popup.contentContainer.find(".mfp-dots .mfp-dot").on('click', function () {
                            popup.goTo(Number($(this).attr('data-index')));
                            popup.updateItemHTML();
                        });
                    }
                }
            })
        });
    }

    var whatsappWidget = function () {
        $('.whatsapp-widget').each(function () {
            $(this).hide().delay(2000).fadeIn();
        });
    }


    // Dom Ready
    $(function () {
        retinaLogos();
        headerFixed();
        mobileNav();
        ajaxSubscribe.eventLoad();
        ajaxContactForm();
        alertBox();
        swiper_tab();
        swiper_tab2();
        swiper_tab3();
        tabs();
        goTop();
        AOS.init();
        flatAccordion();
        flatAccordions2();
        dropdown('#artworks');
        dropdown('#category');
        flatCounter();
        popupVideo();
        sticky();
        Preloader();
        instagramCarousel();
        whatsappWidget();
    });

    new Swiper(".mySwiper3", {
        slidesPerView: 1,
        spaceBetween: 0,
        navigation: {
            nextEl: ".next-swiper3",
            prevEl: ".prev-swiper3",
        }
    });

    new Swiper(".testimonialSwiper", {
        spaceBetween: 30,
        pagination: {
            el: ".testimonials-pagination",
            clickable: true,
        },
    });

    new Swiper(".blogSwiper", {

        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },

        breakpoints: {
            0: {
                slidesPerView: 1,
                spaceBetween: 30,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 30,
            },
            991: {
                slidesPerView: 3,
                spaceBetween: 30,
            },
        },
    });


    new Swiper(".popularSwiper", {

        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },

        breakpoints: {
            0: {
                slidesPerView: 1,
                spaceBetween: 30,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 30,
            },
            991: {
                slidesPerView: 3,
                spaceBetween: 30,
            },
        },
    });
    new Swiper(".partner-type-6", {
        direction: "horizontal",
        effect: "slide",
        slidesPerView: 2,
        loop: true,
        spaceBetween: 68.95,
        breakpoints: {
            500: {
                slidesPerView: 3,
            },
            800: {
                slidesPerView: 4,
            },
            1200: {
                slidesPerView: 5,
            },
            1600: {
                slidesPerView: 6,
            },
        },
        autoplay: {
            delay: 3000,
        },
    });

    new Swiper(".swiperchoose", {
        loop: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });

    new Swiper(".testimonialPortfolio", {
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },


        breakpoints: {
            0: {
                slidesPerView: 1,
                spaceBetween: 30,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 0,
            },
            992: {
                slidesPerView: 3,
                spaceBetween: 0,
            },
        },
    });

    new Swiper(".testimonialPortfolio1", {
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },


        breakpoints: {
            0: {
                slidesPerView: 1,
                spaceBetween: 30,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 30,
            },
            992: {
                slidesPerView: 3,
                spaceBetween: 30,
            },
        },
    });

    new Swiper(".testimonialPortfolio3", {

        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,



    });


    new Swiper(".testimonialPortfolio4", {

        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
                spaceBetween: 30,
            },
            991: {
                slidesPerView: 2,
                spaceBetween: 30,
            },
            1440: {
                slidesPerView: 3,
                spaceBetween: 30,
            },
        },


    });

    new Swiper(".testimonialPortfolio3", {

        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,



    });

    new Swiper(".aboutSwiper", {

        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,

    });

})(jQuery);
